import React, { Fragment, useState } from "react";
import { Form, Icon, Input } from "semantic-ui-react";

export default function ClientCreate(props) {
  let {
    createClientOnboarding,
    totalEnvOptions,
    setFormData,
    formData,
    errors,
    isEdit
  } = props;

  const handleChange = (e, { name, value }) => {
    setFormData({ ...formData, [name]: value });
  };

  const [visible, setVisible] = useState(false);

  return (
    <>
      <Form onSubmit={createClientOnboarding}>
        <Form.Group widths="equal">
            <Form.Dropdown
                name="env"
                required
                label="Environment"
                placeholder="environment"
                search
                selection
                value={formData.env}
                options={totalEnvOptions}
                onChange={handleChange}
                readOnly={isEdit}
                error={
                  errors.env
                    ? {
                        content: "Please select the env",
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Dropdown>

              <Form.Field
                control={Input}
                required
                label="Client Name"
                name="clientName"
                value={formData.clientName}
                placeholder="client name"
                onChange={handleChange}
                readOnly={isEdit}
                error={
                  errors.clientName
                    ? {
                        content: errors.clientName,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
            {/* </> 
          )}*/}
          <Form.Field
            control={Input}
            label="Client Email"
            name="clientEmail"
            required
            value={formData.clientEmail}
            placeholder="client email"
            onChange={handleChange}
            error={
              errors.clientEmail
                ? {
                    content: errors.clientEmail,
                    pointing: "above",
                  }
                : null
            }
          ></Form.Field>
        </Form.Group>
        <Form.Group widths="4">
          <Form.Dropdown
            name="webhookAuthType"
            label="Webhook Auth Type"
            selection
            clearable
            defaultValue=""
            value={formData.webhookAuthType}
            options={[
              {
                key: "Basic Auth",
                text: "Basic Auth",
                value: "BASIC_AUTH",
              },
              {
                key: "OAuth2",
                text: "OAuth 2.0",
                value: "OAUTH2",
              },
            ]}
            onChange={handleChange}
          ></Form.Dropdown>
          {(formData.webhookAuthType === "OAUTH2" ||
            formData.webhookAuthType === "BASIC_AUTH") && (
            <Fragment>
              <Form.Field
                control={Input}
                required
                name="webhookAuthId"
                label="Webhook Username"
                value={formData.webhookAuthId}
                placeholder="Webhook Username"
                onChange={handleChange}
                error={
                  errors.webhookAuthId
                    ? {
                        content: errors.webhookAuthId,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
              <Form.Field
                control={Input}
                required ={!isEdit}
                type={visible ? "text" : "password"}
                name="webhookAuthSecret"
                label="Webhook Password"
                value={formData.webhookAuthSecret}
                placeholder="Webhook Password"
                onChange={handleChange}
                icon={
                  <Icon
                    name={visible ? "eye slash" : "eye"}
                    link
                    onClick={() => setVisible(!visible)}
                  />
                }
                error={
                  errors.webhookAuthSecret
                    ? {
                        content: errors.webhookAuthSecret,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
            </Fragment>
          )}
          {formData.webhookAuthType === "OAUTH2" && (
            <Form.Field
              control={Input}
              name="webhookScope"
              label="Webhook Scope"
              value={formData.webhookScope}
              placeholder="Webhook Scope"
              onChange={handleChange}
              error={
                errors.webhookScope
                  ? {
                      content: errors.webhookScope,
                      pointing: "above",
                    }
                  : null
              }
            ></Form.Field>
          )}
        </Form.Group>
        <Form.Group widths="4">
        {formData.webhookAuthType === "OAUTH2" && (
          <Fragment>
            <Form.Field
              control={Input}
                required
                name="webhookTokenUrl"
                label="Webhook Token URL"
                value={formData.webhookTokenUrl}
                placeholder="Webhook Token URL"
                onChange={handleChange}
                error={
                  errors.webhookTokenUrl
                    ? {
                        content: errors.webhookTokenUrl,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
              <Form.Field
                control={Input}
                name="webhookContentType"
                label="Webhook Content Type"
                value={formData.webhookContentType}
                placeholder="Webhook Content Type"
                onChange={handleChange}
                error={
                  errors.webhookContentType
                    ? {
                        content: errors.webhookContentType,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
              <Form.Field
                control={Input}
                name="webhookGrantType"
                label="Webhook Grant Type"
                value={formData.webhookGrantType}
                placeholder="Webhook Grant Type"
                onChange={handleChange}
                error={
                  errors.webhookGrantType
                    ? {
                        content: errors.webhookGrantType,
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Field>
            </Fragment>
          )}
        </Form.Group>
        <Form.Group widths="12">
        <Form.Field>
          <label>Webhook URLs (JSON format)</label>
          <textarea
            rows={6}
            style={{ width: "100%", fontFamily: "monospace" }}
            value={formData.webhooksMap}
            onChange={e => setFormData({ ...formData, webhooksMap: e.target.value })}
          />
          <span style={{ color: '#888', fontSize: 12 }}>
            Example: {'{"defaultURL": "https://example.com/api", "taskUrl": "https://example.com/api/task", "siteUrl": "https://example.com"}'}
          </span>
        </Form.Field>
        </Form.Group>
        <Form.Button
          color="blue"
          style={{ paddingTop: "10px" }}
          content= {isEdit ? "Update Client" : "Onboard Client"}
          onSubmit={createClientOnboarding}
        />
      </Form>
    </>
  );
}
